import { auth } from '../utils/firebase';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export const DAILY_TOKEN_LIMIT = 200000;

const EMPTY_USAGE = { byModule: {}, totalTokens: 0, limitExceeded: false, dailyLimit: DAILY_TOKEN_LIMIT };

// Today's token usage for the signed-in admin's organisation (resolved server-side).
// Non-critical UI data: any failure reports zero usage rather than throwing.
export const getDailyTokenUsage = async () => {
  try {
    const token = await auth.currentUser.getIdToken();
    const res = await fetch(`${API_URL}/api/ai/daily-usage`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return EMPTY_USAGE;
    return await res.json();
  } catch {
    return EMPTY_USAGE;
  }
};
